const feedbackCard = {
  title: 'Feedback',
  by: 'Por:',
  phone: 'Telefone:',
  via: 'via',
  notes: 'Notas',
  submit: 'Adicionar feedback',
  source: {
    CrewLink: 'CrewLink',
    QR: 'QR',
    TripCard: 'Cartão de viagem',
  },
};

export default feedbackCard;
